import { useCallback, useEffect, useState } from 'react';
import { Flex } from '../../../component-library';
import { calibrationConstants } from '../../../helpers/calibration-constants';
import { useReceiveMessage, usePostMessage } from '../../../context/messageContext';
import { useVideo } from '../../../context/videoContext';
import { LocalVideo, RemoteVideo } from '../../../2022-component-library';

const CornersFixation = () => {
  const { blindSpotThumbnailWidthPx, blindSpotThumbnailHeightPx } = calibrationConstants;
  const [currentVideoPosition, setCurrentVideoPosition] = useState({ top: '50%', left: '50%', centered: true });
  const messageFromOptician = useReceiveMessage();
  const postMessage = usePostMessage();
  const { room } = useVideo();
  const [imgUrls, setImgUrls] = useState([]);
  const [transitionMovement, setTransitionMovement] = useState(true);
  const [videoElement, setVideoElement] = useState();

  const videoPositionStyles = {
    position: 'absolute',
    padding: 'inherit',
    transition: transitionMovement ? 'all 2s ease' : 'none',
    top: currentVideoPosition.top,
    left: currentVideoPosition.left,
    transform: currentVideoPosition.centered ? 'translate(-50%, -50%)' : null,
  };

  const captureImage = useCallback(() => {
    const canvas = document.createElement('canvas');
    canvas.width = blindSpotThumbnailWidthPx;
    canvas.height = blindSpotThumbnailHeightPx;
    const context = canvas.getContext('2d');
    context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
    setImgUrls((prevUrls) => [...prevUrls, canvas.toDataURL('image/png')]);
  }, [blindSpotThumbnailHeightPx, blindSpotThumbnailWidthPx, videoElement]);

  useEffect(() => {
    if (messageFromOptician?.type === 'cornersFixation') {
      setCurrentVideoPosition(messageFromOptician.content);
    }
    if (messageFromOptician?.type === 'enableTransitionMovement') {
      setTransitionMovement(true);
    }
    if (messageFromOptician?.type === 'disableTransitionMovement') {
      setImgUrls([]);
      setTransitionMovement(false);
    }
  }, [messageFromOptician]);

  useEffect(() => {
    if (!currentVideoPosition.centered) {
      const opticianTransitionTime = 3500;
      const callCaptureImage = setTimeout(() => captureImage(), opticianTransitionTime - 100);
      return () => clearTimeout(callCaptureImage);
    }
  }, [currentVideoPosition, captureImage]);

  useEffect(() => {
    setVideoElement(room?.localParticipant?.sid ? document.getElementById(room.localParticipant.sid) : null);
  }, [room?.localParticipant?.sid]);

  useEffect(() => {
    if (imgUrls.length === 4) {
      postMessage({ type: 'cornersFixationImgUrls', content: imgUrls });
      setImgUrls([]);
    }
  }, [imgUrls, postMessage]);

  return (
    <Flex bg='white' width='100vw' height='100vh' style={{ padding: '20px' }}>
      <Flex style={videoPositionStyles} width={blindSpotThumbnailWidthPx} height={blindSpotThumbnailHeightPx}>
        <LocalVideo />
      </Flex>
      <Flex bg='white' width={blindSpotThumbnailWidthPx} height={blindSpotThumbnailHeightPx} style={videoPositionStyles}>
        {/* <Participant participant={participants} /> */}
        <RemoteVideo />
      </Flex>
    </Flex>
  );
};

export default CornersFixation;
